import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from './AuthContext.tsx';

/**
 * Обёртка для маршрутов, требующих аутентификации
 * (`docs/modules/auth.md §4.1`).
 *
 *  - Пока AuthContext ещё грузит /me — показываем спиннер на весь
 *    экран. Важно: не редиректим сразу на /login, иначе будет мигание
 *    при F5 на защищённой странице (cookie ещё валидна, запрос /me
 *    в процессе).
 *  - Если анонимный — редирект на /login с сохранением `from` в
 *    location.state, чтобы после входа вернуть туда же.
 */
export function ProtectedRoute({ children }: PropsWithChildren): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        data-testid="auth-loading"
      >
        <Spin size="large" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
